module.exports = __webpack_public_path__ + "img/green_036.c98f4625.png";